<template>
  <div class="clearfix avatar-user">
    <div class="comp-info-div">
      <div style="line-height: 39px;margin-right: 15px">
        <i class="screen-icon iconfont icon-shuaxin" title="刷新" @click="refresh()"></i>
        <i v-if="!isFull" class="screen-icon iconfont icon-full-screen" title="全屏" @click="fullScreen()"></i>
        <i v-else class="screen-icon iconfont icon-cancel-full-screen" title="取消全屏" @click="fullScreen()"></i>
        <i title="导出列表" class="screen-icon el-icon-download" style="font-size: 18px" @click="openExportList"></i>
      </div>
      <el-avatar style="margin: 0;" :size="40" :src="$fileBaseUrl + '40x40/' + user.userLogo"
                 v-if="user && user.userLogo"></el-avatar>
      <el-avatar style="margin: 0;" :size="40" :src="$ssoUrl + '/images/user/logo.png'" v-else></el-avatar>
    </div>
    <el-dropdown @command="handleCommand" trigger="hover" :hide-on-click="false" @visible-change="kuangHide">
      <div class="comp-info-div">
        <div class="el-dropdown-link" style="cursor: pointer;line-height:40px;margin-left: 5px">
          <span style="color: #fff;" v-if="user">
            {{ user.realName }}
            ({{ user.phone }})
          </span>
          <span style="color: #fff;" v-else>{{ account && account.phone }}</span>
          <i style="color: white" class="el-icon-arrow-down"></i>
        </div>
      </div>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="1">
          <div class="drop-down-my">
            <i class="el-icon-paperclip icon-down"></i>
            <span>前往云平台</span>
          </div>
        </el-dropdown-item>
        <el-dropdown-item command="2" v-if="user">
          <div class="drop-down-my">
            <i class="el-icon-user icon-down"></i>
            <span>我的资料</span>
          </div>
        </el-dropdown-item>
        <el-dropdown-item command="3" v-if="user">
          <div class="drop-down-my">
            <i class="el-icon-lock icon-down"></i>
            <span>修改密码</span>
          </div>
        </el-dropdown-item>
        <el-dropdown-item command="4" v-if="user && compList.length > 1">
          <div class="drop-down-my replace-user">
            <i class="el-icon-sort icon-down" style="transform:rotate(-90deg)"></i>
            <span>切换企业</span>
            <div class="replace-user-div" v-show="showUser">
              <div
                  class="replace-div"
                  v-for="comp in compList"
                  :title="comp.compName"
                  :key="comp.compId"
                  :class="{ 'select-item': comp.compId === compInfo.compId }"
                  :style="{ 'padding': comp.isMainComp == 1 ? '5px 20px 10px 10px' : '' }"
                  @click="replaceComp(comp)"
              >
                {{ comp.compName }}
                <i class="el-icon-s-flag icon-flag" style="display: inline-block;color: #7B7B7B"
                   v-if="comp.isMainComp == 1" title="设置为主企业" @click.stop="setZhuQiye(comp)"></i>
                <i class="el-icon-s-flag icon-flag" v-if="comp.isMainComp != 1" title="设置为主企业"
                   @click.stop="setZhuQiye(comp)"></i>
              </div>
            </div>
          </div>
        </el-dropdown-item>
        <el-dropdown-item command="5">
          <div class="drop-down-my">
            <i class="el-icon-setting icon-down"></i>
            <span>退出系统</span>
          </div>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <el-dialog title="我的资料" :visible.sync="myinfoVisible" v-if="myinfoVisible" width="30%"
               :before-close="(() => myinfoVisible = false)" append-to-body>
      <div class="my-info-dialog">
        <div class="comp-info-div">
          <el-avatar style="margin: 0;display: inline-table;" :size="70" :src="$fileBaseUrl + '70x70/' + user.userLogo"
                     v-if="user.userLogo"></el-avatar>
          <el-avatar style="margin: 0;" :size="70" :src="$ssoUrl + '/images/user/logo.png'"
                     v-if="!user.userLogo"></el-avatar>
          <span class="comp-name" :title="compInfo.compName">{{ compInfo.compName }}</span>
        </div>
        <div class="my-info-div">
          <span>姓名：</span>
          <span>{{ user.realName }}</span>
        </div>
        <div class="my-info-div">
          <span>电话：</span>
          <span>{{ user.phone }}</span>
        </div>
        <div class="my-info-div">
          <span>部门：</span>
          <span>{{ user.departmentName || '-' }}</span>
        </div>

        <div class="tishi">
          <i class="el-icon-info"></i>
          <span>页面信息暂不支持修改，如要修改请前往APP中修改</span>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="myinfoVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
    <!--  导出列表  -->
    <ExportList ref="exportList"/>
  </div>
</template>

<script>
import {CacheService} from "@/service/common";
import screenfull from 'screenfull'
import ExportList from "@/components/header-comp/export-list"

export default {
  name: 'Header',
  data() {
    return {
      isFull: false,
      avaUrl: "https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png",
      user: {},
      account: '',
      compList: this.$store.state.compList || [],
      myinfoVisible: false,
      showUser: false,
      compInfo: '',
    }
  },
  watch: {
    $route() {
      this.getBreadcrumb()
    }
  },
  mounted() {
    this.user = CacheService.get("user");
    this.account = CacheService.get("account");
    this.compInfo = CacheService.get("comp") || {};
  },
  created() {
    this.getBreadcrumb()
  },
  methods: {
    kuangHide(data) {
      !data && (this.showUser = data);
    },
    setZhuQiye(comp) {
      if (comp.isMainComp == 1) {
        this.$message.warning("当前企业已经是主企业了");
        return false;
      }
      this.$confirm('是否设置该企业为主企业，下次登录可直接进入该企业?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.put(`/Yunos/Employee/ModifyMainComp?compId=${comp.compId}`, "").then(res => {
          this.$message.success("设置成功！")
          let compObjList = this.$store.state.compList;
          compObjList.forEach(c => {
            if (c.compId == comp.compId) {
              c.isMainComp = 1;
            } else {
              c.isMainComp = 0;
            }
          })
          this.$store.commit("setCompList", compObjList);
        })
      }).catch(() => {
      });
    },
    replaceComp(item) {
      if (item.compId === this.compInfo.compId) {
        this.$message.warning("已在当前企业！")
        return
      }
      if (!(item.compLevel >= 2)) {
        return this.$message.error('该企业还未认证，请先进行认证');
      }
      if (!item.isAdminRole) {
        return this.$message.error('您没有该企业操作权限！');
      }
      this.$axios.get(`/Yunos/User/ChangeComp?compId=${item.compId}`).then(r => {
        this.$axios.get(`/Yunos/Employee/CompEmployeeInfo`).then(res => {
          if (!res.isAdminRole) {
            return this.$message.error('没有权限！');
          }
          CacheService.set("user", res);
          this.$store.commit("setUser", {data: res});
          CacheService.set("comp", item);
          this.$store.commit('setComp', {data: item})
          this.$router.push(this.$router.options.routes[0].children[0].path)
          this.$router.go(0)
        })
      })
    },
    fullScreen() {
      this.isFull = !this.isFull
      screenfull.toggle();
    },
    refresh() {
      this.$router.go(0);
    },
    getBreadcrumb() {

    },
    handleCommand(command) {
      let that = this
      switch (command) {
        case '1':
          window.open(this.$cloudUrl, '_self')
          break;
        case '2':
          that.myinfoVisible = true
          break;
        case '3':
          window.open(`${this.$ssoUrl}/Acount/ResetPassword`);
          break;
        case '4':
          this.compList.length && (that.showUser = true)
          break;
        case '5':
          that.layout()
          break;
        default:
          break;
      }
    },
    layout() {
      this.$confirm('确定要退出当前用户吗?', '退出登录', {
        confirmButtonText: '退出',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.clearStorage();
      }).catch(() => {
      });
    },
    clearStorage() {
      CacheService.clear();
      this.$store.state.comp = "";
      this.$store.state.compList = [];
      this.$store.state.user = {};
      this.$store.state.menu = [];
      this.$store.state.auth = [];
      this.$store.state.activeName = "";
      top.location = `${this.$ssoUrl}/Acount/Logout?returnUrl=${this.$localUrl}`;
    },
    // 打开导出列表
    openExportList() {
      this.$refs.exportList.open();
    }
  },
  components: {
    ExportList
  }
}
</script>
<style scoped lang="scss">
.my-info-dialog {
  padding: 0 30px;

  .tishi {
    border-top: 1px solid #979797;
    color: #a6a6a6;
    margin-top: 30px;
    padding-left: 30px;

    span {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
    }
  }

  .my-info-div {
    font-size: 15px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    margin: 10px 30px;

    span:first-child {
      color: #666666;
    }

    span:nth-child(2) {
      color: #333333;
      margin-left: 20px;
    }
  }
}

::v-deep .replace-user {
  position: relative;

  .replace-user-div {
    position: absolute;
    top: 0;
    left: -180px;
    margin: 5px;
    background-color: #fff;
    border: 1px solid #ebeef5;
    border-radius: 4px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    line-height: 17px;
    width: 150px;
    text-align: center;
    height: 494px;
    overflow: auto;

    .replace-div {
      padding: 5px 10px;
      line-height: 30px;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      position: relative;

      &:hover {
        background-color: #e0f0ff;
        color: #1890ff;
        padding: 5px 20px 10px 10px;

        .icon-flag {
          display: inline-block;
        }
      }

      .icon-flag {
        position: absolute;
        right: -5px;
        width: 20px;
        line-height: 30px;
        display: none;
      }
    }

    .select-item {
      background-color: #e0f0ff;
      color: #1890ff;
    }
  }
}

::v-deep .drop-down-my {
  padding: 5px 10px 5px 0;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #777777;
  line-height: 20px;

  .icon-down {
    padding: 5px 10px;
  }

  &:hover {
    color: #1890ff;
  }
}

.comp-info-div {
  display: flex;

  .comp-name {
    line-height: 70px;
    margin-left: 20px;
    font-size: 20px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;

    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .user-logo-div {
    width: 70px;
    height: 70px;
    border-radius: 50%;
    text-align: center;
    line-height: 70px;
    background-color: #108cee;
    color: white;
    font-size: 20px;
  }

  .screen-icon {
    font-size: 16px;
    color: white;
    margin-left: 15px;
    cursor: pointer;
  }
}

.avatar-user {
  margin: 0 auto;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
  float: right;
  display: flex;

  .head-menu,
  .head-comp {
    height: 40px;
    line-height: 40px;
    color: #fff;
    font-size: 17px;
  }
}
</style>
